import React from "react";
import StatusIndicator from "./status";
import { Button, CopyValue } from "../../..";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { getFlightApprovalSearchUrl, isFlightApprovalReadyToBook } from "Utils/flightApproval";

function FlightBookingStatus({ booking = {} }) {
	const NAVIGATE = useNavigate();
	const { id, status, approvalRequest, adminRequest } = booking;
	const showBookNow = isFlightApprovalReadyToBook(booking);
	const searchUrl = getFlightApprovalSearchUrl(booking);

	return (
		<div className="p-2 border-t flex-center-between bg-whitish">
			{showBookNow && searchUrl ? (
				<Button onClick={() => NAVIGATE(searchUrl)} variant="primary" className="btn-xs">
					Book Now <FiArrowRight className="ml-1" />
				</Button>
			) : (
				<CopyValue className="text-xxs">
					{approvalRequest ? "AIR/APP" : adminRequest ? "AIR/REQ" : "AIR"}-{id}
				</CopyValue>
			)}
			<StatusIndicator status={status} />
		</div>
	);
}

export default FlightBookingStatus;
